import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleReduceSideBar } from "../../../store/app/actions";
import { RootState } from "../../../store/combineReducer";

function ButtonBurger({ className }: any): JSX.Element {
  const dispatch = useDispatch();
  const { reduceSideBar } = useSelector((state: RootState) => state.app);

  const handleStatusSideBar = useCallback(() => {
    dispatch(handleReduceSideBar(!reduceSideBar));
  }, [dispatch, reduceSideBar]);

  return (
    <button className={className} onClick={handleStatusSideBar}>
      <img src="/images/BurgerMenu.svg" alt="BurgerMenu" />
    </button>
  );
}

export default React.memo(ButtonBurger);
